export default {
  "NoticeConfigSummary.Title": "お知らせ配信の設定",
  "NoticeConfigSummary.Text": "お知らせ、メルマガの受信設定ができます",
}
